import axios from "axios";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { baseUrl } from "utils/baseUrl";
import instance from "../lib/axiosInterceptor";
import { getSubdomainInfo } from "../utils/subdomainDetection";
import SpeakerLandingPage from "views/User/SpeakerLandingPage";
// import { validateToken } from "utils/checkAuthorization";
//
export default function AuthRoute({ children }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  // Check subdomain first
  const subdomainInfo = getSubdomainInfo();

  // If username subdomain and root path, show public speaker page
  if (subdomainInfo.isUserSubdomain && location.pathname === "/") {
    return <SpeakerLandingPage username={subdomainInfo.username} />;
  }

  const storedToken = JSON.parse(localStorage.getItem("user"))?.token;
  const urlOrigin = window.location.origin;
  const urlPathName = window.location.pathname;
  const getTestMode = new URLSearchParams(window.location.search);
  let OAuthCode = searchParams.get("code");

  // Only redirect tweek→stagepanda for app subdomain
  if (
    urlOrigin.includes("tweek") &&
    subdomainInfo.isAppSubdomain &&
    !urlOrigin.includes("development")
  ) {
    window.location.href = "https://app.stagepanda.com" + urlPathName;
  }

  // Authentication redirect logic moved to authGuardLoader (src/routes/loaders/authGuardLoader.ts)
  // The loader runs before this component mounts, preventing timing conflicts
  // with the login flow navigation (e.g., navigate to /onboarding)
  // This component now only handles subdomain checks and OAuth processing
  // if (storedToken && validateToken() && !OAuthCode) {
  //   return <Navigate to="/overview" replace />;
  // }

  if (!storedToken && !OAuthCode) {
    return children;
  }

  const JobTitle = async () => {
    const res = await instance.get(`/Account/MyProfile`);
    //  setDataFromProfile(res.data);
    return res;
  };

  // I don't think any of our resent implementation uses this
  if (OAuthCode) {
    axios
      .post(
        `${baseUrl}/Account/OAuth/Token?code=${encodeURIComponent(
          OAuthCode
        )}&decoded=${true}`
      )
      .then(async (res) => {
        const result = res?.data;
        const { fullName, phone, roles, token, validity, email } = result ?? {};
        if (result) {
          let userDetails = {
            token,
            user: fullName,
            exp: validity,
            phone,
            roles,
            email,
          };
          localStorage.setItem("user", JSON.stringify(userDetails));
          // navigate("/admin/dashboard");
          // Determine whether or not  to redirect theuser to onboarding
          let onboardingData;
          try {
            onboardingData = await JobTitle();
          } catch (e) {}

          if (
            onboardingData &&
            (onboardingData.data.jobTitle === "" ||
              onboardingData.data.linkedIn === "" ||
              onboardingData.data.location === "")
          ) {
            navigate("/onboarding");
            return;
          }

          navigate("/overview");
        }
      })
      .catch((err) => {

      });
  }

  return children;
}
